import { GRAY_700 } from 'constants/styling/theme'
import { GalleryImage } from 'components/common/Gallery/GalleryImage'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'

/**
 * Client gallery low quality disclaimer card
 *
 * @example <ClientGalleryLowQualityDisclaimerCard />
 */
export const ClientGalleryLowQualityDisclaimerCard = () => {
  const theme = useTheme()
  const { t } = useTranslation(['gallery'])

  const isMobileView = useMediaQuery(theme.breakpoints.down('lg'))

  return (
    <GalleryImage>
      <Stack padding={{ xs: 1, md: 2, l: 4 }}>

        <Typography paddingTop={{ xs: 1, l: 2 }} paddingBottom={{ xs: 1, l: 0 }} variant={isMobileView ? 'text-xs' : 'text-md'} fontWeight="bold">{t('client_gallery.low_quality_disclaimer.title')}</Typography>

        <Typography paddingBottom={{ xs: 1, l: 2 }} variant={isMobileView ? 'body1' : 'text-sm'} fontWeight="regular" color={GRAY_700}>{t('client_gallery.low_quality_disclaimer.description')}</Typography>

      </Stack>
    </GalleryImage>
  )
}
